// Utilidades para checklists ([] tildables) armados con el editor
// vue2-editor/Quill dentro de un campo de texto enriquecido. Quill los
// renderiza como <ul data-checked="true|false"><li>...</li></ul> -- cada
// <li> representa un item, y Quill agrupa los <li> consecutivos que
// comparten el mismo estado bajo un único <ul>.
//
// Sin dependencia de Vue: se puede usar tanto desde ChecklistViewer.vue
// como desde cualquier otro lugar que solo necesite el status (ej. un
// badge en un listado) sin renderizar nada.

function getChecklistItems(html) {
  if (!html) return []
  var doc = new DOMParser().parseFromString(html, 'text/html')
  return Array.prototype.slice.call(doc.querySelectorAll('ul[data-checked] > li'))
}

export default {
  // null: no tiene checklist. 'empty': ningún item tildado. 'partial':
  // algunos tildados. 'complete': todos tildados.
  getStatus(html) {
    if (!html || html.indexOf('data-checked') === -1) return null

    var items = getChecklistItems(html)
    if (!items.length) return null

    var checked = items.filter(function(li) {
      return li.parentElement.getAttribute('data-checked') === 'true'
    }).length

    if (checked === 0) return 'empty'
    if (checked === items.length) return 'complete'
    return 'partial'
  },

  // Tilda/destilda el item en la posición targetIndex (orden de aparición
  // entre todos los <li> de checklist del html) y devuelve el html
  // reconstruido, o null si no hay nada que hacer.
  //
  // Como un <ul data-checked> puede agrupar varios <li>, tocar solo uno
  // sin romper el orden ni el estado de sus hermanos requiere repartir
  // cada <li> del checklist en su propio <ul data-checked> -- visualmente
  // idéntico (mismo CSS, ul[data-checked] > li), y Quill lo vuelve a
  // interpretar igual si el usuario reabre el editor.
  toggleAt(html, targetIndex) {
    if (!html) return null

    var doc = new DOMParser().parseFromString(html, 'text/html')
    var body = doc.body
    var index = 0
    var node = body.firstChild

    while (node) {
      var next = node.nextSibling

      if (node.nodeType === 1 && node.tagName === 'UL' && node.hasAttribute('data-checked')) {
        var wasChecked = node.getAttribute('data-checked') === 'true'
        var items = Array.prototype.slice.call(node.children)

        items.forEach(function(li) {
          var checked = (index === targetIndex) ? !wasChecked : wasChecked
          index++

          var newUl = doc.createElement('ul')
          newUl.setAttribute('data-checked', checked ? 'true' : 'false')
          newUl.appendChild(li)
          body.insertBefore(newUl, node)
        })

        body.removeChild(node)
      }

      node = next
    }

    return body.innerHTML
  },
}
